/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosInstance } from 'axios';

import { AuthAPI, baseUrl } from '../../common/authAPI';
import { sleepForever } from '@utils/time';

export const authClient = (request: AxiosInstance): AuthAPI => ({
  async logout() {
    window.location.href = `${baseUrl}/logout`;
    await sleepForever(); // stop application progress and wait for redirect to take effect
  },

  // eslint-disable-next-line @typescript-eslint/require-await
  async login(_redirectUrl: string) {
    // note: participants don't have a way to login
    throw Error('Participant login not implemented');
  },

  async ping() {
    await request.get(`${baseUrl}/ping`);
  },

  async expire() {
    window.location.href = `${baseUrl}/expire`;
    await sleepForever(); // stop application progress and wait for redirect to take effect
  },
});
